import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { NavLink } from 'react-router-dom'
import moment from 'moment'
import { Element } from 'react-scroll'
import FileInputField from '../../../components/FileInputField'
import DatePickerFormComponent from '../../../components/redux-form/DatePickerFormComponent'
import { MenuItem, DropdownButton } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as solidIcons from '@fortawesome/free-solid-svg-icons'
import { getVehicleIcon } from 'libs/vehicles'
import NewVehicleModal from 'components/Vehicles/NewVehicleModal'
import DisableForm from './DisableForm'
import { areObligatoryDocsSelected, getDocumentColor, checkDurationMark, getMarkExpirationDate, MARK_TYPE_ELECTRIC, MARK_TYPE_FAMILY, MARK_TYPE_GREEN, MARK_TYPE_HYBRID, MARK_TYPE_ZTL_DISABILI } from 'libs/marks'
import { MARK_ENABLE_START_DATE } from 'libs/settings'
import SostaOnlineApiService from 'services/SostaOnlineApiService'

class MarkRequest extends Component {

  static propTypes = {
    user: PropTypes.object,
    disableTitle: PropTypes.string,
    onMarkTypeSelected: PropTypes.func.isRequired,
    selectedMarkType: PropTypes.object,
    selectedVehicles: PropTypes.arrayOf(PropTypes.object),
    settings: PropTypes.object,
    documents: PropTypes.array,
    errors: PropTypes.string,
    onVehicleSelected: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    onVehicleAdd: PropTypes.func,
    onVehicleRemove: PropTypes.func,
    price: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    markRules: PropTypes.object,
    submitting: PropTypes.bool,
    markTypes: PropTypes.arrayOf(PropTypes.object),
    selectedDocuments: PropTypes.arrayOf(PropTypes.object),
    onDocumentAdd: PropTypes.func,
    onDocumentRemove: PropTypes.func,
    onDocumentChange: PropTypes.func,
    onDateChange: PropTypes.func,
    handleSubmit: PropTypes.func,
    selectedStartDate: PropTypes.string,
    onCloseFileManager: PropTypes.func
  }

  /**
   * --------------------------------------------------------------------------
   * @param {*} props 
   */
  constructor(props) {
    super(props)

    this.state = {
      showNewVehicleModal: false,
      showDisableModel: false,
      title: '',
      prices: [],
      isSelfBoxPlaceAutoChecked: false,
      isResident: false
    }

    this.onCloseNewVehicleModal = this.onCloseNewVehicleModal.bind(this)
    this.showNewVehicleModal = this.showNewVehicleModal.bind(this)
    this.showDisableModel = this.showDisableModel.bind(this)
    this.onVehicleSelected = this.onVehicleSelected.bind(this)
    this.onAddVehicle = this.onAddVehicle.bind(this)
    this.getMarkTypePrices = this.getMarkTypePrices.bind(this)
  }

  /**
   * --------------------------------------------------------------------------
   * 
   */
  async componentDidMount() {

    const config = await SostaOnlineApiService.fetchPublicConfigs();    

    this.setState({
      showNewVehicleModal: false,
      showDisableModel: false,
      prices: await this.getMarkTypePrices(),
      enableBoxBonificoUser: config.data.enableBoxBonificoUser,
      enableBoxPagoPaUser: config.data.enableBoxPagoPaUser,
      bonificoLabel1: config.data.bonificoLabel1,
      bonificoLabel2: config.data.bonificoLabel2,
      bonificoLabel3: config.data.bonificoLabel3,
      bonificoLabel4: config.data.bonificoLabel4,
      pagoPaLabel1: config.data.pagoPaLabel1,
      pagoPaLabel2: config.data.pagoPaLabel2,
      pagoPaLabel3: config.data.pagoPaLabel3,
      pagoPaLabel4: config.data.pagoPaLabel4,
      pagoPaLabel5: config.data.pagoPaLabel5,
      pagoPaLabel6: config.data.pagoPaLabel6,
      pagoPaLabel7: config.data.pagoPaLabel7,
      linkPagopa: config.data.linkPagopa,
      selfDichiarationNoboxNoplaceAuto: config.data.miscellaneous.selfDichiarationNoboxNoplaceAuto,      
      isResident: false
    })
  }

  /**
   * --------------------------------------------------------------------------
   * @param {*} prevProps 
   */
  async componentDidUpdate(prevProps) {
    if (this.props.selectedStartDate != prevProps.selectedStartDate) {
      this.setState({
        prices: await this.getMarkTypePrices()
      })
    }

    const currentMarkTypeId = this.props.selectedMarkType?.id
    const prevMarkTypeId = prevProps.selectedMarkType?.id

    if (currentMarkTypeId !== prevMarkTypeId) {
      const isResident = currentMarkTypeId ? await this.fetchSelectedMarkTypeIsResident(currentMarkTypeId) : false

      if (isResident !== this.state.isResident) {
        this.setState({ isResident })
      }
    }

  }

  /**
   * --------------------------------------------------------------------------
   * 
   */
  onCloseNewVehicleModal() {
    this.setState({ showNewVehicleModal: false })
  }  

  /**
   * --------------------------------------------------------------------------
   * 
   */
  showNewVehicleModal() {
    this.setState({ showNewVehicleModal: true })
  }

  /**
   * --------------------------------------------------------------------------
   * @param {*} vehicleId 
   */
  onVehicleSelected(vehicleId) {

    if (vehicleId != null && this.props.onVehicleSelected) {
      this.props.onVehicleSelected(vehicleId)
    }
    else {
      this.showNewVehicleModal()
    }

  }

  /**
   * --------------------------------------------------------------------------
   * @param {*} vehicle 
   */
  onAddVehicle(vehicle) {
    if (this.props.onVehicleAdd)
      this.props.onVehicleAdd(vehicle)

  }

  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
  areSelectedVehicles() {
    var filter = this.props.selectedVehicles.filter(item => (item.id != null || item.type === 'new'))
    return filter.length > 0
  }

  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
  getUserVehicles() {
    var result = []
    var vehicles = []

    const {
      user,
      selectedMarkType,
      selectedVehicles
    } = this.props

    if (user && user.vehicles) {

      vehicles = user.vehicles

      if (selectedMarkType) {
        if (selectedMarkType.type === MARK_TYPE_HYBRID) {
          vehicles = vehicles.filter(item => item.VehiclePowerSupply.hybrid)
        }
        else if (selectedMarkType.type === MARK_TYPE_ELECTRIC) {
          vehicles = vehicles.filter(item => item.VehiclePowerSupply.electric)
        }
        else if (selectedMarkType.type === MARK_TYPE_GREEN) {
          vehicles = vehicles.filter(item => (item.VehiclePowerSupply.hybrid || item.VehiclePowerSupply.electric))
        }
      }

      vehicles.map(v => {

        var find = selectedVehicles.filter(sv => sv.id === v.id)

        if (find.length <= 0)
          result.push(v)

      })

    }

    return result

  }

  /**
   * --------------------------------------------------------------------------
   */
  showSelectStartDateStep(selectedMarkType) { 
    
    var settings = this.props.settings   

    if (selectedMarkType && selectedMarkType.type === MARK_TYPE_FAMILY) {    
      return selectedMarkType && selectedMarkType.type === MARK_TYPE_FAMILY
    }

    if (selectedMarkType && selectedMarkType.type === MARK_TYPE_ZTL_DISABILI) {
      return selectedMarkType && selectedMarkType.type === MARK_TYPE_ZTL_DISABILI
    }

    if (settings[MARK_ENABLE_START_DATE] && settings[MARK_ENABLE_START_DATE].value == "1") {
      return selectedMarkType && settings[MARK_ENABLE_START_DATE].value == "1"
    } else {
      return false
    }    
    
  }

  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
  async fetchSelectedMarkTypeIsResident(markTypeId) {
    try {
      const response = await SostaOnlineApiService.fetchMarkType(markTypeId)
      return response.data?.Categories?.some(
        category => category.name === 'RESIDENTE e DIMORANTE (da almeno 3 mesi)'
      ) ?? false
    } catch (error) {
      console.error('Errore durante il recupero del tipo di contrassegno:', error)
      return false
    }
  }

  showSecondStep(selectedMarkType, markRules, selectedStartDate) { 
    var settings = this.props.settings
    var duration = null

    if (selectedMarkType == null || markRules == null) {
      return false
    }

    if (selectedMarkType.type == MARK_TYPE_FAMILY) {
      var setting = settings[selectedMarkType.id]

      if (setting == null)
        return false

      duration = parseInt(setting.value)
    }

    return (
      !this.props.markLimitReached &&
      selectedMarkType &&
      markRules.id &&
      (
        (selectedMarkType.type !== MARK_TYPE_FAMILY ) ||
        (selectedMarkType.type !== MARK_TYPE_FAMILY && settings[MARK_ENABLE_START_DATE].value == "0" && moment(selectedStartDate).add(duration, 'days').isAfter(moment(), 'days')) ||
        (selectedMarkType.type !== MARK_TYPE_FAMILY && settings[MARK_ENABLE_START_DATE].value == "1" && selectedStartDate != null && moment(selectedStartDate).add(duration, 'days').isAfter(moment(), 'days')) ||
        (selectedMarkType.type === MARK_TYPE_FAMILY && selectedStartDate != null)
        // (selectedMarkType.type === MARK_TYPE_FAMILY && selectedStartDate != null && moment(selectedStartDate).add(duration, 'days').isAfter(moment(), 'days'))
      )
    )

  }

  /**
   * --------------------------------------------------------------------------
   * @param {*} selectedMarkType 
   * @param {*} markRules 
   * @returns 
   */
  showThirdStep(selectedMarkType, markRules, selectedStartDate) {    
    return (
      this.showSecondStep(selectedMarkType, markRules, selectedStartDate) &&
      this.areSelectedVehicles() &&
      this.props.documents.length > 0
    )
  }

  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
   showFinalStep(selectedMarkType, markRules, price, selectedStartDate, isSelfBoxPlaceAutoChecked) {   
    
    let checkboxValidated = true;
    if (selectedMarkType && selectedMarkType.selfDeclarationMarkType) {
      checkboxValidated = !this.state.selfDichiarationNoboxNoplaceAuto || isSelfBoxPlaceAutoChecked
    }    

    return (
      checkboxValidated &&
      this.showSecondStep(selectedMarkType, markRules, selectedStartDate) &&
      this.areSelectedVehicles() &&
      this.areObligatoryDocsSelected() &&
      price != null
    )
  }

  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
  areObligatoryDocsSelected() {
    var {
      documents,
      selectedDocuments
    } = this.props

    return areObligatoryDocsSelected(documents, selectedDocuments)
  }

  /**
   * --------------------------------------------------------------------------
   * @param {*} document 
   * @returns 
   */
  getDocumentColor(document) {
    return getDocumentColor(document, this.props.selectedDocuments)
  }

  /**
   * --------------------------------------------------------------------------
   * 
   */
  async getMarkTypePrices() {

    var {
      user,
      markTypes,
      selectedStartDate
    } = this.props

    var prices = []

    for (let markTypeKey in markTypes) {

      var markType = markTypes[markTypeKey]

      prices[markType.id] = null

      if (markType.Prices != null && markType.Prices.length > 0) {

        if (user.categories != null && user.categories.length > 0 && markType.Categories != null && markType.Categories.length > 0) {
          
          for (let key in markType.Categories) {
            for (let key1 in user.categories) {
              if (markType.Categories[key].id == user.categories[key1].id) {

                var selectedPrice = await SostaOnlineApiService.fetchMarkPrice(
                  user.id,
                  markType.id,
                  markType.Categories[key].id,
                  null,
                  null,
                  selectedStartDate
                )
                .catch(err => {
                  console.log("ERROR:", err)
                })

                if (selectedPrice != null && selectedPrice.data != null) {
                  prices[markType.id] = selectedPrice.data.price
                  break;
                }

              }
            }

            if (prices[markType.id] != null) {
              break
            }

          }

        }

      }
      else 
      {
        prices[markType.id] = markType.price
      }

    }

    return prices

  }


  /**
   * --------------------------------------------------------------------------
   * 
   */
  checkSelectedStartDate() {    
    
    var {
      selectedStartDate,
      selectedMarkType,
      settings
    } = this.props

    var msg = ""  
    var duration = parseInt(settings[selectedMarkType.id].value, 10)

    if (selectedMarkType.type == MARK_TYPE_FAMILY) {      
      if (moment(selectedStartDate).add(duration, 'days').isBefore(moment(), 'days')) {
        msg = "Errore! Il figlio ha già raggiunto un anno di età."
      }
    }
    // else if (settings[MARK_ENABLE_START_DATE].value == "1" && moment(selectedStartDate).isBefore(moment()) && duration > 0) {
    else if (settings[MARK_ENABLE_START_DATE].value == "1" && moment(selectedStartDate).isBefore(moment())) {
      msg = "La data di validità deve essere successiva alla data odierna"
    }   

    return msg
  }

  /**
   * --------------------------------------------------------------------------
   * @param {*} item 
   * @returns 
   */
  getMarkTypePriceDescription(item) {

    const {
      prices
    } = this.state

    if (prices[item.id] == null) {
      return (<h3 className="title3">Non Disponibile</h3>)
    }

    else if (!item.free || parseFloat(prices[item.id]) > 0) {
      return (
        <h3 className="title3">
          {parseFloat(prices[item.id]).toFixed(2) + " €"}
        </h3>)
    }

    else {
      return (<h3>Gratuito</h3>)
    }
  }

  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
  showDisableModel() {
    return (
      this.setState({ showDisableModel: true })
    )
  }

  /**
   * --------------------------------------------------------------------------
   * @param {*} item 
   * @returns 
   */
  async takeDisableTitle(item) {
    let {
      permanentMark
    } = this.state

    if (item.typeName == "DOMANDA DI RILASCIO/RINNOVO CONTRASSEGNO PERMANENTE") {
      return (
        this.permanentMark = item.typeLabel
      )
    } else if (item.typeName == "DOMANDA DI RILASCIO/RINNOVO CONTRASSEGNO TEMPORANEO") {
      return (
        this.permanentMark = item.typeLabel
      )
    }
  }

  /**
 * --------------------------------------------------------------------------
 * @param {*} item 
 * @returns 
 */
  async getTitle(item) {    
    try {
      this.title = await this.takeDisableTitle(item);
      console.log('il titolo', this.title);
      return;
    } catch (e) {
      console.log("Si è verificato un errore!");
    }
  }

  /**
 * --------------------------------------------------------------------------
 * @returns 
 */
  closeDisableModel() {
    return (
      this.setState({ showDisableModel: false })
    )
  }
  
  async openSelfDeclarationPdf(fileName) {
    if (!fileName || typeof fileName !== 'string') {
      return
    }

    const normalizedFileName = fileName.trim()

    if (!normalizedFileName) {
      return
    }

    try {
      const blob = await SostaOnlineApiService.downloadSelfDeclarationFile(normalizedFileName)

      if (blob) {
        const pdfUrl = window.URL.createObjectURL(blob)
        window.open(pdfUrl, '_blank', 'noopener,noreferrer')
      }
    } catch (error) {
      console.error('Errore durante l’apertura del modulo di autocertificazione:', error)
    }
  }

  // /**
  // * --------------------------------------------------------------------------
  // * @returns 
  // */
  async handleSelfBoxPlaceAuto(event) {
    if (event && event.target) {
      const isChecked = event.target.checked
      this.setState({ isSelfBoxPlaceAutoChecked: isChecked })

      if (isChecked && this.props.selectedMarkType && this.props.selectedMarkType.selfDeclarationMarkTypeFileName) {
        await this.openSelfDeclarationPdf(this.props.selectedMarkType.selfDeclarationMarkTypeFileName)
      }
    }
  }  

  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
  getSortedDocuments() {
    return [...this.props.documents].sort((a, b) => (b.mandatory === true) - (a.mandatory === true))
  }

  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
  render() {
    const {
      markTypes,
      loading,
      settings,
      errors,
      documents,
      onMarkTypeSelected,
      selectedMarkType,
      selectedVehicles,
      markRules,
      onVehicleRemove,
      price,
      submitting,
      selectedDocuments,
      onDocumentAdd,
      onDocumentRemove,
      onDocumentChange,
      onDateChange,
      selectedStartDate,
      selectedEndDate,
      onCloseFileManager,
      user
    } = this.props


    console.log('selectedMarkType: ' , selectedMarkType);
    

    const {
      showNewVehicleModal
    } = this.state

    console.log('documents: ' , documents);
    

    let {
      showDisableModel,
      enableBoxBonificoUser,
      enableBoxPagoPaUser,
      bonificoLabel1,
      bonificoLabel2,
      bonificoLabel3,
      bonificoLabel4,
      pagoPaLabel1,
      pagoPaLabel2,
      pagoPaLabel3,
      pagoPaLabel4,
      pagoPaLabel5,
      pagoPaLabel6,
      pagoPaLabel7,
      linkPagopa,
      selfDichiarationNoboxNoplaceAuto
    } = this.state    

    if (loading) {
      return (
        <div>Caricamento in corso...</div>
      )
    }

    if (user == null || user.userConfirmed == null || !user.userConfirmed)
      return (
        <div className="col-md-8 col-md-push-2">
          <h5 className="title-danger text-center" style={{ minHeight: "40em" }}>
            <strong>Attenzione! </strong>
            <br />
            <br />
            Non hai ancora confermato la tua mail,{' '}
            il download e l'acquisto dei permessi sarà disponibile solo a mail confermata
          </h5>
        </div>
      )

    // TODO gestire l'iscrizione a categorie non attive per l'utente
    return (
      <form onSubmit={this.props.handleSubmit(values => {
        this.props.onSubmit({ ...values })
      })}>
        <div className="col-md-10 col-md-push-1">
          <div className="panel panel-default panel-border">
            <div className="panel-body">
              <NavLink to="/user-area" className="btn mainBtn" style={{ margin: 20 }}>Torna indietro</NavLink>
              <h2 className="title title-special">Richiedi Permesso</h2>
              {process.env.REACT_APP_CITYL === 'Faenza' ? 
              (
                <p>Da quì puoi richiedere l'iscrizione in Lista Bianca per l'accesso in ZTL della Città di {process.env.REACT_APP_CITYL}<br /></p>
              ) : 
              (
                <p>Da quì puoi richiedere un nuovo permesso per la sosta nel Comune di {process.env.REACT_APP_CITYL}<br /></p>
              ) 
              }
              {/* SEZIONE PERMESSI ABILITATI PER L'UTENTE */}
              <div className="box">
                {markTypes != '' 
                ?
                <fieldset>

                  {/* INTESTAZIONE PERMESSI ABILITATI PER L'UTENTE */}
                  <div className="titolo-categoria">
                    <legend className="text-left">Tipologia Permesso</legend>
                    <p>Seleziona il tipo di permesso di cui necessiti tra quelli disponibili per il tuo utente</p>
                  </div>

                  {/* ELENCO PERMESSI ABILITATI PER L'UTENTE */}            
                  <div className="row">
                    {markTypes.map((item, i) => {

                      let activeClass = ''
                      const multipleAreas = item.Areas.length > 1

                      if (selectedMarkType && selectedMarkType.id === item.id) {
                        activeClass = ' active'
                      }

                      return (
                        <div key={i} className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <div
                            onClick={() => onMarkTypeSelected(item)}
                            className={'panel panel-default park-ticket-panel panel-border' + activeClass}>
                            <div className="panel-body-dark text-center" >
                              <h4 style={{ color: item.color == null || item.color.toUpperCase() == "#FFFFFF" ? "#5a5a5a" : item.color }}><strong>{item.label}</strong></h4>
                              {this.getMarkTypePriceDescription(item)}
                              <div className="panel-body-dark flex-grow panel-2">
                                Valido nell{multipleAreas ? 'e' : 'a'} zon{multipleAreas ? 'e' : 'a'}:{' '}
                                {item.Areas.map((areaItem, index) => (
                                  <span key={index}>
                                    <strong>{areaItem.code}</strong>
                                    {index === item.Areas.length - 1 ? '' : ', '}
                                  </span>
                                ))}
                                <br />
                                {item.type === MARK_TYPE_FAMILY &&
                                  ( <span>Valido fino al: <strong>primo anno del figlio</strong></span> )
                                }
                                {item.type === MARK_TYPE_ZTL_DISABILI ?
                                  ( <span>Valido fino alla scadenza del contrassegno di parcheggio per disabile</span> )
                                   :
                                  (
                                    (checkDurationMark(settings, item).check ? 
                                      (  <span>Durata di {' ' + checkDurationMark(settings, item, null).value} {checkDurationMark(settings, item, null).value === 1 ? 'giorno' : 'giorni'}</span> )
                                      :
                                      ( <span>Valido fino al:{' ' + getMarkExpirationDate(settings, item, null).format("L")}</span> )
                                    )
                                  )
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                    <Field name="markType" component="input" type="hidden" />
                  </div>
                 
                </fieldset>
                :
                <div className="titolo-categoria">
                  {/* <legend className="text-left">Tipologia Permesso</legend> */}
                  <p><strong>ATTENZIONE: area o categoria non utilizzabili per ottenere un titolo di parcheggio</strong></p>
                </div>              
                }
              </div>

              {/* SEZIONE RICHIESTA CON SELEZIONE DATA DI INIZIO VALIDITA' */}              
              {this.showSelectStartDateStep(selectedMarkType) && (selectedMarkType.type !== MARK_TYPE_ZTL_DISABILI) && (
                <div className="box">
                  <Element name="child-borndate" />
                  <div className="titolo-categoria">
                    {selectedMarkType.type === MARK_TYPE_FAMILY ?
                      <React.Fragment>
                        <legend className="text-left">Data di nascita del figlio</legend>
                        <p>Il contrassegno Family è valido fino al compimento di <strong>1 anno</strong>.</p>
                      </React.Fragment> :
                      <React.Fragment>
                        <legend className="text-left">Data</legend>
                      </React.Fragment>
                    }
                  </div>
                  <div className="row">
                    <div className="col-md-4 text-left">
                      {selectedMarkType.type === MARK_TYPE_FAMILY ?
                        <label>Data di Nascita del figlio</label> :
                        <label>Data di inizio validità permesso</label>
                      }
                      <Field
                        placeholderText="GG/MM/AAAA"
                        component={DatePickerFormComponent}
                        name="selectedStartDate"
                        className="mainField"
                        onDateChange={onDateChange}
                        selected={selectedStartDate}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text-danger">
                        {this.checkSelectedStartDate()}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* SEZIONE RICHIESTA CON SELEZIONE DATA DI FINE VALIDITA' (AD ORA UTILIZZATO SOLO PER TIPO PERMESSO ZTL_DISABILI) */}
              {this.showSelectStartDateStep(selectedMarkType) && selectedMarkType.type === MARK_TYPE_ZTL_DISABILI && (
                <div className="box">
                  <Element name="child-borndate" />
                  <div className="titolo-categoria">
                    {selectedMarkType.type === MARK_TYPE_ZTL_DISABILI ?
                      <React.Fragment>
                        <legend className="text-left">Il permesso sarà valido fino alla scadenza del contrassegno di parcheggio per disabile</legend>
                        <p className="text-left">L'attivazione del permesso è subordinata all'approvazione da parte del personale addetto.<br />
                        Durante la circolazione in ZTL dovrà essere esposto il contrassengo del parcheggio per disabile.<br />
                        Il permesso si intende valido esclusivamente quando il veicolo è al servizio del disabile.</p>
                        <legend className="text-left"></legend>
                      </React.Fragment> :
                      <React.Fragment>
                        <legend className="text-left">Data</legend>
                      </React.Fragment>
                    }
                  </div>
                  <div className="row">
                    <div className="col-md-4 text-left">
                      {selectedMarkType.type === MARK_TYPE_ZTL_DISABILI ?
                        <label>Data di scadenza del contrassegno di parcheggio per disabile</label> :
                        <label>Data di scadenza validità permesso</label>
                      }
                      <Field
                        placeholderText="GG/MM/AAAA"
                        component={DatePickerFormComponent}
                        name="selectedEndDate"
                        className="mainField"
                        onDateChange={onDateChange}
                        selected={selectedEndDate}
                        required
                      />
                    </div>
                  </div>                  
                  {/* <div className="row">
                    <div className="col-md-12">
                      <div className="text-danger">
                        {this.checkSelectedStartDate()}
                      </div>
                    </div>
                  </div> */}
                </div>
              )}

              {/* SEZIONE VEICOLI */}
              <Element name="step-two" />
              {/* {this.showSecondStep(selectedMarkType, markRules, selectedStartDate) && (settings[MARK_ENABLE_START_DATE].value == "1" && moment(selectedStartDate).isAfter(moment())) && */}
              {this.showSecondStep(selectedMarkType, markRules, selectedStartDate, this.markTypeSelfDichiaration) &&  
                <div className="box">
                  <fieldset>
                    <div className="titolo-categoria">

                      <legend className="text-left">Veicoli</legend>

                      <h4>
                        Questo permesso è utilizzabile su un massimo di {markRules.vehicleLimit} veicol{markRules.vehicleLimit > 1 ? 'i' : 'o'}
                      </h4>

                      <div className="row">
                        <div className="col-md-12 text-left">

                          <DropdownButton
                            id="AddVehicle"
                            title="SCEGLI VEICOLO"
                            className="mainBtn"
                            dropup
                            onSelect={(vehicleId) => { this.onVehicleSelected(vehicleId) }}
                          >
                            <MenuItem eventKey={null} style={{ minWidth: "400px", padding: "0px", margin: "0" }}>
                              <h4 style={{ margin: "5px", padding: "3px" }}>
                                <span><FontAwesomeIcon size="1x" className="sectionIcons" icon={solidIcons.faPlusCircle} />&nbsp;&nbsp;</span>
                                <span><strong>Nuovo Veicolo</strong></span>
                              </h4>
                            </MenuItem>
                            {
                              this.getUserVehicles().map((item) =>
                                <MenuItem key={"select-vehicle-" + item.id} eventKey={item.id} style={{ minWidth: "400px", padding: "0px", margin: "0" }}>
                                  <h4 style={{ margin: "5px", padding: "3px" }}>
                                    <span>{getVehicleIcon(item.VehiclePowerSupply, "1x")}&nbsp;&nbsp;</span>
                                    <span><strong>{item.plate_number}&nbsp;&nbsp;</strong></span>
                                    <span>{item.VehiclePowerSupply.name}</span>
                                  </h4>
                                </MenuItem>
                              )
                            }
                          </DropdownButton>

                          <span className={selectedVehicles.length >= markRules.vehicleLimit ? 'text-danger' : 'text-primary'}>
                            <strong>{' Veicoli Utilizzati: ' + selectedVehicles.length} / {markRules.vehicleLimit}</strong>
                          </span>
                        </div>
                      </div>

                    </div>

                    {selectedVehicles.map((item, index) => {
                      return (
                        <div className="row row-list-body" key={'vehicle-' + index} >

                          <div className="col-sm-1 text-left cell-list-body ">
                            <div style={{ marginTop: 5, paddingLeft: 15 }}>{getVehicleIcon(item.VehiclePowerSupply, "2x")}</div>
                          </div>

                          <div className="col-sm-3 text-left cell-list-body ">
                            <div style={{ marginTop: 5 }}><strong>{item.plate_number}</strong></div>
                          </div>

                          <div className="col-sm-3 text-left cell-list-body">
                            <div style={{ marginTop: 5 }}>{item.VehiclePowerSupply.name}</div>
                          </div>

                          <div className="col-sm-4 text-left cell-list-body">
                            <div style={{ marginTop: 5 }}>{item.VehicleOwnershipType.name}</div>
                          </div>

                          <div className="col-sm-1 cell-list-body">
                            <div onClick={() => onVehicleRemove(index)} className="alertBtn">
                              <FontAwesomeIcon size="1x" icon={solidIcons.faTrash} />
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </fieldset>
                </div>
              }

              {/* SEZIONE CARICAMENTO DOCUMENTI */}
              <Element name="step-three" />
              {this.showThirdStep(selectedMarkType, markRules, selectedStartDate) &&
                <div className="box">
                  <fieldset>
                    <div className="titolo-categoria">
                      <legend className="text-left">Documenti </legend>
                      <span className="text-center col-md-12" >                      

                      {enableBoxBonificoUser && selectedMarkType.pagopaSpont &&
                        <><span style={{ fontWeight: 'bold', textDecorationLine: 'underline' }}>Prima di inviare la richiesta occorrerà disporre il pagamento a mezzo bonifico bancario</span>
                          <div className="row row-list-body mb-5 p-3 center text-left">
                            Dicitura informativa per il bonifico:<br />
                            <div style={{ fontWeight: 'bold', fontSize: 'small', color: 'red' }}>
                              {bonificoLabel1}<br />
                              {bonificoLabel2}
                              {bonificoLabel3}<br />
                              {bonificoLabel4}
                            </div>
                          </div></>
                        }

                        {enableBoxPagoPaUser && selectedMarkType.pagopaSpont &&
                        <><span style={{ fontWeight: 'bold', textDecorationLine: 'underline' }}>Prima di inviare la richiesta occorrerà disporre il pagamento a mezzo sistema PagoPA</span>
                          <div className="row row-list-body mb-5 p-3 center text-left">
                            <span style={{ textDecorationLine: 'underline', color: 'black' }}>Dicitura informativa per il pagamento tramite PagoPA:</span><br />
                            <div style={{ fontSize: 'small', color: 'black' }}>
                              {pagoPaLabel1}<br />
                              <a href={linkPagopa} target="_blank"><b>{linkPagopa}</b></a><br />
                              {pagoPaLabel2}<br />
                              {pagoPaLabel3}<br />
                              {pagoPaLabel4}<br />
                              Servizio: '<b>PARCOMETRI - ABBONAMENTI</b>' - Causale di pagamento: '<b>NOME/COGNOME E TARGA</b>' - Importo: <b>{selectedMarkType.price} €</b><br />
                              {pagoPaLabel5}<br />
                              {pagoPaLabel6}<br />
                              {pagoPaLabel7}<br />
                            </div>
                          </div></>
                        }

                        {/* <!--h4 className="text-center col-md-12">La richiesta di questo permesso richiede l'upload dei seguenti documenti:</h4--> */}
                        <h4 className="text-center col-md-12"> ( in ROSSO obbligatoria, in GIALLO facoltativa ):</h4>
                        {this.getSortedDocuments().map((item, index) => {
                          return (
                            item.typeLabel == "DOCUMENTO CON MARCA DA BOLLO" ? (
                              <p key={"doc-" + index} style={{ color: 'black', fontWeight: '500' }}>
                                <strong>N.B.: </strong>Per il documento <span style={{ color: 'red' }}>"DOCUMENTO CON MARCA DA BOLLO"</span>, scaricare il fac simile al seguente link, compilarlo e applicare la marca da bollo nell'apposito spazio. Dopodichè scannerizzare e allegare il documento alla richiesta di permesso.&nbsp;&nbsp;<a href="#">Clicca qui!!!</a>
                              </p>
                            ) : item.typeName == "DOMANDA DI RILASCIO/RINNOVO CONTRASSEGNO PERMANENTE" | item.typeName == "DOMANDA DI RILASCIO/RINNOVO CONTRASSEGNO TEMPORANEO" ? (
                              <p key={"doc-" + index} style={{ color: 'black', fontWeight: '500' }}>
                                <strong>N.B.: </strong>Per allegare il documento <span style={{ color: 'red' }}>"{item.typeLabel}'"</span>, cliccare il pulsante qui sotto, compilare il modello e scaricarlo in formato PDF. Infine allegarlo alla richiesta di permesso.<br></br>
                                <button type="button" className="mainBtn" onBlur={this.getTitle(item)} onClick={this.showDisableModel}>Clicca qui!!!</button>
                              </p>
                            ) : ('')
                          )
                        })}
                        <strong className="text-center col-md-12">
                          <ul className="text-left">
                            { selfDichiarationNoboxNoplaceAuto && selectedMarkType.selfDeclarationMarkType &&
                              <li>
                                <Field
                                  name="selfBoxPlaceAuto"
                                  component="input"
                                  type="checkbox"
                                  style={{ marginRight: '10px' }}
                                  onChange={(event) => this.handleSelfBoxPlaceAuto(event)}
                                  required
                                />
                                <label>{selectedMarkType.selfDeclarationMarkTypeLabel}</label>
                              </li>
                            }
                            {this.getSortedDocuments().map((item, index) => {
                              var color = this.getDocumentColor(item)                              
                              return (
                                <li key={"doc-" + index} style={{ 'color': color }} >
                                  {item.typeLabel} {item.mandatory ? "( obbligatorio )" : "( facoltativo )"}
                                </li>
                              )
                            })}
                          </ul>
                        </strong>
                      </span>
                      <p>I file caricati devono essere nel formato: png, jpeg, pdf.</p>
                    </div>

                    <div className="row">
                      <div className="col-md-12 text-left">
                        <a type="button" className="mainBtn" onClick={onDocumentAdd}>
                          Allega Documento
                        </a>
                      </div>
                    </div>

                    <br />

                    {selectedDocuments.map((item, index) => {

                      return (
                        <div className="form-group row row-list-body" key={'document-' + index + '-' + item.id}>

                          <div className="col-sm-6 text-left  cell-list-body " >
                            <div style={{ textOverflow: 'ellipsis', marginLeft: 15, paddingTop: 10 }}>
                              <strong>{item.DocumentType ? item.DocumentType.label : 'Seleziona un documento'}</strong>
                            </div>
                          </div>

                          <div className="col-sm-5 text-left cell-list-body" >
                            <Field
                              openFileManager={item.openFileManager}
                              documentTypeId={item.documentTypeId}
                              onChange={(document) => { onDocumentChange(document, index) }}
                              onClose={onCloseFileManager}
                              name={'documentFile-' + index + '-' + item.id}
                              component={FileInputField}
                              required
                            />
                          </div>

                          <div className="col-sm-1 text-left cell-list-body">
                            <div onClick={() => onDocumentRemove(index)} className="alertBtn" >
                              <FontAwesomeIcon size="1x" icon={solidIcons.faTrash} />
                            </div>
                          </div>

                        </div>
                      )
                    })}
                  </fieldset>
                </div>
              }

              <div className={(showDisableModel === false ? 'hidden' : 'show')} style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#FFFFFF44', display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(8px)', width: '100%', height: '100%' }}>
                  <DisableForm
                    user={user}
                    disableTitle={this.title}
                  />
                  <div style={{ position: 'absolute', zIndex: 101, top: 465, right: 170, fontSize: '25px' }}>
                    <button type="button" onClick={() => this.closeDisableModel()} className="glyphicon glyphicon-remove chiudi-btn"></button>
                  </div>
                </div>
              </div>

              {/* SEZIONE RIEPILOGO E INVIO RICHIESTA */}
              <Element name="step-final" />
              {this.showFinalStep(selectedMarkType, markRules, price, selectedStartDate, this.state.isSelfBoxPlaceAutoChecked) &&
                <div className="box">
                  <fieldset>
                    <div className="titolo-categoria">
                      <legend className="text-left">Riepilogo</legend>
                    </div>

                    <div className="col-md-6">
                      <div className="card-marks">
                        <div className="caption" style={{ padding: 10 }}>
                          <h5>
                            <strong>{selectedMarkType.label}</strong>
                          </h5>
                          <h5>
                            Valido nell{selectedMarkType.Areas.length > 1 ? 'e' : 'a'} zon{selectedMarkType.Areas.length > 1 ? 'e' : 'a'}:{' '}
                            {selectedMarkType.Areas.map((areaItem, index) => (
                              <span key={index}>
                                <strong>{areaItem.code}</strong>
                                {index === selectedMarkType.Areas.length - 1 ? '' : ', '}
                              </span>
                            ))}
                          </h5>
                          {selectedMarkType.Categories && selectedMarkType.Categories.length > 0 && selectedMarkType.Categories[0] && selectedMarkType.Categories[0].MarkTypeCategories && selectedMarkType.Categories[0].MarkTypeCategories.periodo &&
                            <h5>
                              Periodo: <strong>{selectedMarkType.Categories[0].MarkTypeCategories.periodo}</strong>
                            </h5>
                          }
                          {selectedMarkType.Categories && selectedMarkType.Categories.length > 0 && selectedMarkType.Categories[0] && selectedMarkType.Categories[0].MarkTypeCategories && selectedMarkType.Categories[0].MarkTypeCategories.sosta &&
                            <h5>
                              Sosta: <strong>{selectedMarkType.Categories[0].MarkTypeCategories.sosta}</strong>
                            </h5>
                          }
                          <h5>
                            Targ{selectedVehicles.length > 1 ? 'he' : 'a'}: <strong>{selectedVehicles.map(item => item.plate_number + ' ')}</strong>
                          </h5>
                          
                          {selectedMarkType.type !== MARK_TYPE_ZTL_DISABILI && selectedStartDate &&
                            <h5>
                              Valido dal : <strong>{moment(selectedStartDate).format('L')}</strong>
                            </h5>
                          }                       
                          
                          {selectedMarkType.type === MARK_TYPE_ZTL_DISABILI &&
                            <h5>
                              Valido fino al : <strong>{moment(selectedEndDate).format('L')}</strong>
                            </h5>
                          }
                          {selectedMarkType.selfDeclarationMarkTypeLabel && selectedMarkType.selfDeclarationMarkType &&
                            <h5>                              
                              <strong><mark>{selectedMarkType.selfDeclarationMarkTypeLabel}</mark></strong>
                            </h5>
                          }
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <h3>Totale: € {Number(price.price).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h3>
                      {price.reasons && price.reasons.length > 0 ? price.reasons.map((item, index) => {
                        return (
                          <h5 className="text-info" key={'reasons-' + index}>{item}</h5>
                        )
                      }) : null}
                    </div>
                  </fieldset>

                  {submitting && <div className="box text-info">Richiesta in corso...</div>}

                  <button type="submit" className="btn mainBtn">
                    Richiedi Permesso
                  </button>
                </div>
              }

              <Element name="errors" />
              {errors &&
                <div>
                  <br /><br />
                  <h4 className="box text-danger">{errors}</h4>
                  <br /><br />
                </div>}

            </div>
          </div>
        </div>

        {/* MODALE AGGIUNTA NUOVO VEICOLO */}

        {selectedMarkType &&
          <NewVehicleModal
            show={showNewVehicleModal}
            onAddVehicle={this.onAddVehicle}
            onClose={this.onCloseNewVehicleModal}
            type={selectedMarkType.type}
          />
        }

      </form>
    )
  }
}

export default reduxForm({ form: 'markRequest', enableReinitialize: true, keepDirtyOnReinitialize: true })(MarkRequest)
